import dayjs from 'dayjs'
import {
  createRecruitingRequestSchema,
  type CreateRecruitingRequest,
} from '../schema/createRecruitingRequest.schema'
import { DateTimeFormats } from 'helpers/datetime'
import {
  CreateInvitationFormValues,
  RecruitingExemptStatusEnum,
} from '../types'

export function mapFormToCreateRecruitingInvitationRequest(
  clientPublicKey: string,
  values: CreateInvitationFormValues
): CreateRecruitingRequest {
  const raw: Record<string, unknown> = {
    clientPublicKey,
    benefitEffectiveDate: dayjs(values.benefitEffectiveDate).format(
      DateTimeFormats.a
    ),
    contributionGroup: values.contributionGroup,
    employmentStatus: values.employmentStatus,
    isExempt: values.exemptStatus === RecruitingExemptStatusEnum.Exempt,
    expiryDays: values.expiryDays,
    isSendEmail: values.isSendEmail,
  }

  const trimmedEmail = values.recipientEmail?.trim()
  if (trimmedEmail) {
    raw.recipientEmail = trimmedEmail
  }

  const trimmedFirst = values.firstName?.trim()
  if (trimmedFirst) {
    raw.firstName = trimmedFirst
  }

  const trimmedLast = values.lastName?.trim()
  if (trimmedLast) {
    raw.lastName = trimmedLast
  }

  if (values.payType) {
    raw.payType = values.payType
  }

  return createRecruitingRequestSchema.parse(raw)
}
